import React from 'react'
import _cx from 'classnames/bind'
import cls from './styles.scss'

const cx = _cx.bind(cls)

export interface SparkleAnimatedIconProps {
  isActive?: boolean
  color?: string
  size?: string
}

/**
 * A 3-sparkle icon where each sparkle can independently beat-fade
 * when isActive is true. Mimics the FontAwesome "sparkles" shape.
 */
const SparkleAnimatedIcon: React.FC<SparkleAnimatedIconProps> = ({
  isActive = false,
  color = '#57c1e8',
  size = '1.8em',
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 512 512'
      width={size}
      height={size}
      className={cx('sparkle-svg')}
      aria-hidden='true'
    >
      {/* Large sparkle - left side, vertically centered */}
      <path
        className={cx({ 'sparkle-beat-1': isActive })}
        fill={color}
        d='M160 56Q180 237 360 256Q180 275 160 456Q140 275 -40 256Q140 237 160 56Z'
      />
      {/* Small sparkle - upper right */}
      <path
        className={cx({ 'sparkle-beat-2': isActive })}
        fill={color}
        d='M400 64Q406 106 448 112Q406 118 400 160Q394 118 352 112Q394 106 400 64Z'
      />
      {/* Medium sparkle - lower right */}
      <path
        className={cx({ 'sparkle-beat-3': isActive })}
        fill={color}
        d='M400 312Q410 382 480 392Q410 402 400 472Q390 402 320 392Q390 382 400 312Z'
      />
    </svg>
  )
}

export default SparkleAnimatedIcon
